import { useEffect, useRef } from '@wordpress/element';
import { render } from '@wordpress/element';

/**
 * Shadow DOM + WP React renderer
 * @param containerRef
 * @param styles
 */
const useShadowDOM = (containerRef, styles) => {
	const shadowRootRef = useRef(null);
	const shadowContainerRef = useRef(null);

	// This is our "React root" – but it's just a wrapper around render().
	const shadowReactRootRef = useRef(null);

	useEffect(() => {
		if (!containerRef.current) {
			return;
		}

		// Reuse existing shadow root
		if (containerRef.current.shadowRoot) {
			shadowRootRef.current = containerRef.current.shadowRoot;
			shadowContainerRef.current = shadowRootRef.current.querySelector(
				'#pingvid-shadow-container'
			);

			if (!shadowReactRootRef.current) {
				shadowReactRootRef.current = (content) =>
					render(content, shadowContainerRef.current);
			}

			return;
		}

		// CREATE new shadow root
		const shadowRoot = containerRef.current.attachShadow({ mode: 'open' });
		shadowRootRef.current = shadowRoot;

		const shadowContainer = document.createElement('div');
		shadowContainer.id = 'pingvid-shadow-container';
		shadowRoot.appendChild(shadowContainer);
		shadowContainerRef.current = shadowContainer;

		const styleElement = document.createElement('style');
		styleElement.textContent = styles;
		shadowRoot.appendChild(styleElement);

		// Create minimal render wrapper
		shadowReactRootRef.current = (content) =>
			render(content, shadowContainer);
	}, [containerRef, styles]);

	return {
		shadowRootRef,
		shadowContainerRef,
		shadowReactRootRef,
	};
};

export default useShadowDOM;
